import React, { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import { connect } from "react-redux";
import Stack from "@mui/material/Stack";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Radio, Paper, Tooltip, ListItem, Typography } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import StackedBarChart from "../StackedBarChart";
import GroupedBarLineChart from "../GroupedBarLineChart";
import GroupedBarMultipleLineChart from "../GroupedBarMultipleLineChart";
import { useSelector } from "react-redux";
import DoBarChart from "../DoBarChart";
import { COFMockData, RedeployCost } from "../../../../data/mockdata";
import DPBarChart from "../DPBarChart";
import DPGroupedBarLineChart from "../DPGroupedBarLineChart";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import BarChart from "../BarChart";
import DPBarMultiple from "../DPBarMultiple";
import GraphService from "../../../../services/console_services/Graph";
import Loading from "../../Loading";
import AccuracyChart from "../AccuracyChart";
import { InputLabel } from "@material-ui/core";
import MultiBarPOOSChart from "../GraphViewPOOS/MultiBarPOOSChart";
import { setModuleTabIndex } from "../../../../store/Actions";
import { styled } from "@mui/material";
import AutoCompleteSearchField from "../AutoCompleteSearchField";
import CustomScrollButton from "../../ReusableComponents/CustomTabScrollButton";
function TabPanel(props) {
  const { children, value, index, ...other } = props;
 
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={1}>{children}</Box>}
    </div>
  );
}
 
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
 
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
 
// Create a styled Tabs component
const CustomTabs = styled(Tabs)({
  "& .MuiTabs-flexContainer": {
    display: "flex",
    flexWrap: "wrap",
    width: "60vw",
  },
});
 
const useStyles = makeStyles((_theme) => ({
  root: {
    flexGrow: 1,
    dispatch: "flex",
    padding: "10px",
  },
  paper: {
    boxShadow: "none !important",
  },
  loader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "58vh",
    width: "100%",
    position: "relative",
    top: 0,
    left: 0,
  },
  select: {
    borderColor: "transparent",
    borderStyle: "none",
    height: "30px",
    width: "120px",
    borderRadius: "4px !important",
    background: "var(--Neutral-Colors-White, #FFF)",
    fontSize: "14px !important",
    color: "#404041 !important",
    "&.MuiOutlinedInput-root": {
      margin: "0px 17px",
    },
  },
  main: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    padding: "0px 10px",
  },
  appBar: {
    padding: "10px",
    "& .MuiTabs-scroller": {
      overflow: "visible !important",
    },
  },
  tab: {
    background: "#FFF",
    boxShadow:
      "0px 2px 4px 0px rgba(0, 0, 0, 0.10), 0px 4px 12px 0px rgba(0, 0, 0, 0.10)",
    flex: 1,
    minHeight: "30px",
    borderRadius: "8px",
  },
  activeTabs: {
    color: "#FFF",
    textAlign: "center",
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    fontWeight: "500",
    textTransform: "none",
    borderRight: "1px solid #92949747",
    minHeight: "30px",
    border: "1px solid var(--Neutral-Colors-Off-White, #E6E7E8)",
    background: "var(--Nestle_Blue, #0067A1)",
  },
  inActiveTabs: {
    color: "#59595A",
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    textTransform: "none",
    minHeight: "30px",
    opacity: 1,
    border: "1px solid var(--Neutral-Colors-Off-White, #E6E7E8)",
    background: "var(--Neutral-Colors-White, #FFF)",
  },
  indicator: {
    display: "none",
  },
  filter: {
    fontSize: "14px",
    margin: "0px 2px",
  },
  dropDownLabel: {
    marginTop: "2px",
  },
}));
 
const networkOptions = [
  { entity: "Network", value: "AMBIENT" },
  { entity: "Network", value: "CHILLED" },
  { entity: "Network", value: "FROZEN" },
  { entity: "Network", value: "NPW" },
];
 
const GraphView_NPS = ({
  tabIndex,
  Module,
  Network,
  DC,
  Products,
  Division,
  PL3,
  graphViewTabList,
  date,
  applyFilter,
  role,
  moduleTabIndexChange,
}) => {
  const classes = useStyles();
  const { instance } = useMsal();
  // const [chartData, setChartData] = useState([]);
  const tabValue = useSelector((state) => state?.tabs?.moduleTabIndex);
  // const [categoryList, setCategoryList] = useState("");
  const [graphData, setGraphData] = useState([]);
  const [loading, setLoading] = useState(true);
  const activeTab = graphViewTabList.filter(
    (item) => item.index === tabValue
  )[0].name;
  const activeFlagValue = useSelector((state) => state?.filter?.activeFlag);
  const entireState = useSelector((state) => state);
  // const [topOrBottomValue, setTopOrBottomValue] = useState("Top");
  const topOrBottomValue = "Top";
  // const [countValue, setCountValue] = useState("5");
  const countValue = "5";
  // const countList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  const [selectedDcOptions, setSelectedDcOptions] = useState([]);
  const [dcOptions, setDcOptions] = useState([]);
  const [selectedNetwork, setSeletedNetwork] = useState("AMBIENT");
  const [isNetworkChanged, setIsNetworkChaged] = useState(false);
  const [isTabChanged, setIsTabChanged] = useState(false);
 
  const getGraphData = (params) => {
    setLoading(true);
    GraphService.getGraph(params, instance)
      .then((data) => {
        if (data?.data) {
          setGraphData(data?.data);
        }
      })
      .catch((error) => console.error("Error:", error))
      .finally(() => setLoading(false));
  };
 
  const memoizedParams = useMemo(
    () => ({
      section: "NPS",
      type: graphViewTabList[tabValue]?.value,
      arrangements: topOrBottomValue,
      value: countValue,
      filter: {
        RecommendedDC: selectedDcOptions?.map((data) => data?.value),
        Network: [selectedNetwork],
        ScenarioName:
          entireState?.filter?.scenarioValue === ""
            ? []
            : [entireState?.filter?.scenarioValue],
        PL3: PL3,
        Division: Division,
        Products: Products,
        startDate: date?.[0],
        endDate: date?.[1],
      },
    }),
    [
      Module,
      tabValue,
      role,
      DC,
      Network,
      PL3,
      Division,
      Products,
      date,
      activeFlagValue,
      entireState?.filter?.scenarioValue,
      selectedDcOptions,
      dcOptions,
    ]
  );
 
  useEffect(() => {
    if (dcOptions?.length > 0) {
      getGraphData(memoizedParams);
    }
  }, [memoizedParams, applyFilter]);
 
  const handleChange = (_event, newValue) => {
    moduleTabIndexChange(newValue);
    updateDataOnTabChange(newValue);
    setIsTabChanged(true);
    setIsNetworkChaged(false);
  };
 
  const getMapedDCData = (params) => {
    GraphService.getMapedDC(params, instance)
      .then((data) => {
        if (data?.data) {
          const dcData = data?.data?.map((item) => ({
            entity: "DC",
            value: item?.LocationId,
          }));
          setDcOptions([...dcData]);
        }
      })
      .catch((error) => console.error("Error:", error));
  };
 
  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem(activeTab));
    if (
      storedData?.network &&
      storedData?.dcOptions?.length > 0 &&
      storedData?.dcOptions[0]
    ) {
      setSeletedNetwork(storedData?.network);
      setSelectedDcOptions(storedData?.dcOptions);
    } else if (isNetworkChanged) {
      //setSelectedDcOptions([dcOptions[0]]);
    }
    setIsNetworkChaged(false);
    setIsTabChanged(false);
  }, [dcOptions]);
 
  useEffect(() => {
    if (!isTabChanged) {
      setIsNetworkChaged(true);
    }
    const params = {
      Network: [selectedNetwork],
    };
    getMapedDCData(params);
    setSelectedDcOptions([]);
 
    let tempData = {
      network: selectedNetwork,
      dcOptions: [],
    };
    localStorage.setItem(activeTab, JSON.stringify(tempData));
  }, [selectedNetwork]);
 
  useEffect(() => {
    let tempData = {
      network: selectedNetwork,
      dcOptions: selectedDcOptions,
    };
    localStorage.setItem(activeTab, JSON.stringify(tempData));
  }, [selectedDcOptions]);
 
  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem(activeTab));
    if (storedData?.network && storedData?.dcOptions?.length > 0) {
      //setSeletedNetwork(storedData?.network);
      //setSelectedMetricOptions(storedData?.dcOptions);
    } else {
      const params = {
        Network: ["AMBIENT"],
      };
      getMapedDCData(params);
    }
  }, []);
 
  const updateDataOnTabChange = (newValue) => {
    const newTab = graphViewTabList?.filter(
      (item) => item?.index === newValue
    )[0]?.name;
    const storedData = JSON.parse(localStorage.getItem(newTab));
    if (storedData?.network && storedData?.dcOptions?.length > 0) {
      setSeletedNetwork(storedData?.network);
      setSelectedDcOptions(storedData?.dcOptions);
    } else {
      //setSelectedDcOptions([dcOptions[0]])
      setSeletedNetwork("AMBIENT");
    }
  };
 
  const handleSelectedNetwork = (event) => {
    setSeletedNetwork(event.target.value);
  };
 
  const renderChart = () => {
    // const chartProps = {
    //     graphData,
    //     chartData,
    //     categoryList,
    //     showAnnotation: true,
    //     activeTab
    // };
 
    return (
      <DPGroupedBarLineChart
        graphData={graphData?.data}
        activeTab={activeTab}
        module={"NPS"}
      />
    );
  };
 
  return (
    <Paper elevation={0} className={classes.paper}>
      {loading ? (
        <div className={classes.loader}>
          <Loading />
        </div>
      ) : (
        <>
          {/* <div className={classes.main}>
                        <div className={classes.appBar}> */}
          <Box
            sx={{
              maxWidth: "70vw",
              overflow: "hidden",
            }}
          >
            <Tabs
              value={tabValue}
              onChange={handleChange}
              className={classes.tab}
              aria-label="simple tabs example"
              variant="scrollable"
              scrollButtons="auto"
              ScrollButtonComponent={CustomScrollButton}
              classes={{ indicator: classes.indicator }}
            >
              {graphViewTabList.map((item, index) => (
                <Tab
                  key={index}
                  className={
                    tabValue === index
                      ? classes.activeTabs
                      : classes.inActiveTabs
                  }
                  label={item.name}
                  style={{
                    minHeight: "35px",
                  }}
                  {...a11yProps(index)}
                />
              ))}
            </Tabs>
          </Box>
          {/* </div>
                    </div> */}
          {graphViewTabList.map((_item, index) => (
            <TabPanel key={index} value={tabIndex} index={index}>
              <Stack direction="row" alignItems="center" sx={{ padding: "22px 8px" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "40px",
                  }}
                >
                  <Select
                    value={selectedNetwork}
                    onChange={handleSelectedNetwork}
                    className={classes.select}
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                    sx={{ ...classes.select,alignSelf:"flex-end" }}
                  >
                    {networkOptions?.map((option) => {
                      return (
                        <MenuItem value={option?.value}>
                          {option?.value}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  <div>
                    <Typography
                      sx={{
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "#aaaaaaff",
                        mb: "4px",
                      }}
                    >
                      Select DC
                    </Typography>
                    <AutoCompleteSearchField
                      selectedMetricOptions={selectedDcOptions}
                      setSelectedMetricOptions={setSelectedDcOptions}
                      metricOptions={dcOptions}
                      style={{ width: "245px" }}
                    />
                  </div>
                </div>
              </Stack>
              {renderChart()}
            </TabPanel>
          ))}
        </>
      )}
    </Paper>
  );
};
 
GraphView_NPS.propTypes = {
  tabIndex: PropTypes.number.isRequired,
  tabChange: PropTypes.func.isRequired,
};
 
const mapStateToProps = (state) => ({
  tabIndex: state.tabs.index,
  Network: state.filter.Network,
  DC: state.filter.DC,
  Products: state.filter.Products,
  PL3: state.filter.PL3,
  date: state.filter.Date,
  Division: state.filter.Division,
  applyFilter: state.filter.applyFilter,
  role: state.login.role,
});
 
const mapDispatchToProps = (dispatch) => ({
  tabChange: (newValue) => dispatch({ type: "TAB_INDEX", payload: newValue }),
  moduleTabIndexChange: (newValue) =>
    dispatch({ type: "MODULE_TAB_INDEX", payload: newValue }),
});
 
export default connect(mapStateToProps, mapDispatchToProps)(GraphView_NPS);